document.addEventListener('click', function(event) {
  const panel = document.getElementById('image-overlay-panel');
  if (!panel) return;

  const imgClicked = event.target.closest('.product-media--grid-wrapper img');
  const overlayBg  = panel.querySelector('.overlay-background');
  const overlayImg = document.getElementById('image-overlay');
  const body       = document.body;

  if (imgClicked) {
    event.preventDefault();
    event.stopPropagation();

    overlayImg.src = imgClicked.src;
    panel.classList.remove('hidden');
    body.classList.add('no-scroll');
    return;
  }

  if (event.target === overlayBg) {
    panel.classList.add('hidden');
    body.classList.remove('no-scroll');
  }
});
